import styles from "../../styles/welcome.module.css";
import { useClient } from "../../provider/ClientProvider";
import { useTranslation } from "react-i18next";

/**
 * Second stage, shown only when the code named an organisation with more than one
 * issuer.
 *
 * Choosing one looks up its issuer code, so this is a step in the same lookup
 * rather than a separate mechanism. A single-issuer organisation never gets here:
 * the server resolves it straight through.
 */
const IssuerStep = () => {
  const { t } = useTranslation();
  const { issuerChoice, lookupCode, cancelIssuerChoice, isResolving } = useClient();

  if (!issuerChoice) return null;

  return (
    <div className={styles.clientIdForm}>
      <ul className={styles.issuerList}>
        {issuerChoice.issuers.map((issuer) => (
          <li key={issuer.issuerCode}>
            <button
              type="button"
              className={styles.issuerOption}
              onClick={() => void lookupCode(issuer.issuerCode)}
              disabled={isResolving}
            >
              <span className={styles.issuerName}>{issuer.issuerName}</span>
              <span className={styles.issuerCode}>{issuer.issuerCode}</span>
            </button>
          </li>
        ))}
      </ul>

      <button
        type="button"
        className={styles.button_secondary}
        onClick={cancelIssuerChoice}
        disabled={isResolving}
      >
        {t("issuer.back")}
      </button>
    </div>
  );
};

export default IssuerStep;
